import { SecureRoute } from '@okta/okta-react';
import React, { FC, Suspense } from 'react';
import { Redirect, Switch, useRouteMatch } from 'react-router';
import { ProjectId } from 'api/models';
import type { Project } from 'api/project';
import { PageLoading } from 'components/atoms/loading';
import { RoutePaths } from 'constant';
import { useAccountMetaQuery } from 'queries';
import {
  ProjectTaskListPage,
  ProjectTaskListPageV2,
} from 'routes/projects/lazy-imports';
import { getProjectTaskListUrl } from 'utils/urls';
import { ProjectTaskBoardPage } from './board';

export const ProjectTasksPage: FC<{
  project: Project;
}> = ({ project }) => {
  const { path } = useRouteMatch();
  const { data: accountMeta } = useAccountMetaQuery();

  const getProjectTaskList = () => {
    // Enabling the new task list page for accounts with clickhouse feature
    if (accountMeta?.features?.clickhouse === true) {
      return <ProjectTaskListPageV2 project={project} />;
    }

    return <ProjectTaskListPage project={project} />;
  };

  return (
    <Suspense fallback={<PageLoading />}>
      <Switch>
        <SecureRoute path={RoutePaths.projectTaskList} exact>
          {getProjectTaskList()}
        </SecureRoute>
        <SecureRoute path={RoutePaths.projectTaskBoard} exact>
          <ProjectTaskBoardPage project={project} />
        </SecureRoute>
        <SecureRoute path={path} exact>
          <Redirect to={getProjectTaskListUrl(ProjectId(project.projectId))} />
        </SecureRoute>
      </Switch>
    </Suspense>
  );
};
